"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using square brackets and hyphens (`[-` `-]`).
 * Matches tags of the form `[-variable-]` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello [-variable-]';
 * const result = replaceTags(text, { variable: 'world' }, SquareBracketsWithHyphens);
 * console.log(result); // Output: 'Hello world'
 */
var SquareBracketsWithHyphens = {
    name: "Square Brackets With Hyphens",
    openingTag: "[-",
    closingTag: "-]",
    tagPattern: /\[-[^-]+?-\]/g,
    tagStartPattern: /^\[-/,
    tagEndPattern: /-\]$/,
};
exports.default = SquareBracketsWithHyphens;
